import FlightTypeSelectInputSFO from "./FlightTypeSelectInputSFO";
import { changeForm } from "../../../searchFlightsSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { FlightTypeSelect } from "../../../../../types";
import { useTranslation } from "react-i18next";

function FlightTypeInputSFO() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const flightType = useAppSelector(
    (state) => state.searchFlights.form.flightType
  );

  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onSelect = (type: FlightTypeSelect) => {
    dispatch(
      changeForm({
        nonStopFlights: type === FlightTypeSelect.NonStop,
        flightType: type,
      })
    );
  };

  return (
    <div className="column sfo-date pl-0 is-one-quarter" id="flight-type">
      <FlightTypeSelectInputSFO
        id="departure-time-input"
        disabled={disabled}
        value={flightType}
        label={t("FLIGHT_TYPE")}
        onSelect={onSelect}
      />
    </div>
  );
}

export default FlightTypeInputSFO;
